import { RichTextFormat } from '../../schema/prismic/fields/text';
import { Document, DocumentType } from '../document';
import { LinkDocument } from '../link';

export type PageType =
  | DocumentType.COLD_ARTICLE
  | DocumentType.FINANCIAL_DEBT
  | DocumentType.FINANCIAL_KEY_FIGURES
  | DocumentType.FINANCIAL_PRESS_RELEASE
  | DocumentType.FINANCIAL_PUBLICATION
  | DocumentType.FINANCIAL_RATING
  | DocumentType.HOME
  | DocumentType.HUB_ACTUS
  | DocumentType.HUB_NEWSROOM
  | DocumentType.HOT_ARTICLE
  | DocumentType.LA_POSTE_EN_4
  | DocumentType.MEDIA_PRESS
  | DocumentType.NEWSROOM
  | DocumentType.PRESS_RELEASE
  | DocumentType.SEARCH;

export type Meta = {
  title?: string;
  description?: string;
  image?: string;
  indexed: boolean;
};

export enum FrequenciesEnum {
  WEEKLY = 'weekly',
  ALWAYS = 'always',
  HOURLY = 'hourly',
  DAILY = 'daily',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  NEVER = 'never',
}

export type Page = Document & {
  type: PageType;
  meta: Meta;
  seoText?: string;
  sitemapPriority: number;
  sitemapChangeFrequency: FrequenciesEnum;
  breadcrumbParent?: LinkDocument;
  breadcrumb: string;
  title: string;
  chapeau?: RichTextFormat[] | void;
  disableRgpbBanner: boolean;
};
